import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { RequisitoRespaldo } from '../_models/requisito-respaldo';
import {RequisitoGarantiaRespaldo} from '../_models/requisito-garantia-respaldo';

@Injectable({
  providedIn: 'root'
})
export class RequisitosRespaldosService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/requisitosGarantiasRespaldos';

  constructor(private httClient: HttpClient, private autServicio: AutenticacionService) {
  }

  listado() {
    return this.httClient.get(this.rutServicio).pipe(map(res => res as RequisitoRespaldo[]));
  }

  listadoHabilitados() {
    return this.httClient.get(this.rutServicio + '/enabled').pipe(map(res => res as RequisitoRespaldo[]));
  }

  listadoHabilitadosPorUnidadCredito(idSolUc: string) {
    return this.httClient.get(this.rutServicio + '/solicitudUnidadCredito/' + idSolUc + '/').pipe(map(res => res as RequisitoRespaldo[]));
  }

  obtenerPorId(id: string) {
    return this.httClient.get(this.rutServicio + '/' + id).pipe(map(res => res as RequisitoRespaldo));
  }

  obtenerPorIdRequisito(id: string) {
    return this.httClient.get(this.rutServicio + '/requisitoGarantia/' + id).pipe(map(res => res as RequisitoRespaldo[]));
  }

  listadoPorIdRequisitoHabilitado(id: string) {
    return this.httClient.get(this.rutServicio + '/requisitoGarantia/' + id + '/enabled').pipe(map(res => res as RequisitoRespaldo[]));
  }

  crear(regCrear: RequisitoRespaldo) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post(this.rutServicio, regCrear).pipe(map(res => res as RequisitoRespaldo));
  }

  bulk(regCrear: RequisitoRespaldo[]) {
    const auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    regCrear.map(x => {
      x.auditoriaUsuario = auditoriaUsuario;
    });
    return this.httClient.post(this.rutServicio + '/bulk', regCrear).pipe(map(res => res as RequisitoRespaldo));
  }

  actualizar(regActualizar: RequisitoRespaldo) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put(this.rutServicio, regActualizar).pipe(map(res => res as any));
  }

  obtenerPorGenerateList(id: string) {
    return this.httClient.get(this.rutServicio + '/generateList/' + id)
      .pipe(map(res => res as any));
  }

  obtenerPorIdRequisitoGarantiaIdSolUC(idRequisitoGarantia: string, idSolUc: string) {
    return this.httClient.get(
      this.rutServicio + '/respaldosObligatorios/requisitoGarantia/' +
      idRequisitoGarantia + '/solicitudesUnidadCredito/' + idSolUc + '/enabled'
    ).pipe(map(res => res as RequisitoRespaldo[]));
  }

  requisitosGarantiasRespaldos(idPlataformaDigital: string) {
    return this.httClient.get( `${this.rutServicio}/digital/respaldosObligatorios/idPlataformaDigital/${idPlataformaDigital}` ).pipe( map( res => res as RequisitoGarantiaRespaldo ) );
  }
}
